import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/layout/AuthShell";
import { Field } from "@/components/shared/Common";
import { api, errMsg } from "@/lib/api";

const Msg = ({ ok, children, testid }) => (
  <div data-testid={testid} className={`rounded-lg border px-3 py-2 text-sm ${ok ? "border-[#bfe6a8] bg-[#e9f7e1] text-[#1c6e00]" : "border-[#f5c2c0] bg-[#fdeaea] text-[#b42318]"}`}>{children}</div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg({ ok: true, text: data.message });
    } catch (err) {
      setMsg({ ok: false, text: errMsg(err) });
    } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Recuperar contraseña" subtitle="Le enviaremos un enlace de un solo uso desde abastecimiento@sycspa.cl.">
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <Field label="Email registrado">
          <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
        </Field>
        {msg && <Msg ok={msg.ok} testid="forgot-message">{msg.text}</Msg>}
        <Button data-testid="forgot-submit-btn" disabled={loading} className="w-full h-11 rounded-full">Enviar enlace</Button>
        <Link to="/login" data-testid="back-to-login-link" className="block text-center text-sm font-semibold text-[#258F00]">Volver al inicio de sesión</Link>
      </form>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [msg, setMsg] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setMsg({ ok: false, text: "Las contraseñas no coinciden" });
    try {
      const { data } = await api.post("/auth/reset-password", { token: params.get("token") || "", password: form.password });
      setMsg({ ok: true, text: data.message });
    } catch (err) {
      setMsg({ ok: false, text: errMsg(err) });
    }
  };
  return (
    <AuthShell title="Nueva contraseña" subtitle="Mínimo 10 caracteres, con letras y números.">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <Field label="Nueva contraseña">
          <Input data-testid="reset-password-input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="h-11" />
        </Field>
        <Field label="Confirmar contraseña">
          <Input data-testid="reset-confirm-input" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required className="h-11" />
        </Field>
        {msg && <Msg ok={msg.ok} testid="reset-message">{msg.text}</Msg>}
        <Button data-testid="reset-submit-btn" className="w-full h-11 rounded-full">Guardar contraseña</Button>
        <Link to="/login" data-testid="reset-back-login-link" className="block text-center text-sm font-semibold text-[#258F00]">Ir a iniciar sesión</Link>
      </form>
    </AuthShell>
  );
}
